export default {"src":"/_next/static/media/ArrowUp.daaf440c.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};